import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import AddInputForm from "../../components/pageManager/AddInputForm";



const GlobalInputFields = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <AddInputForm/>
                </div>
            </div>
        </div>
    );
};

export default GlobalInputFields;
